<script>
export default {
  name: "NotFound",
};
</script>

<template>
  <div class="w-100 d-flex justify-center">
    <v-empty-state
      class="w-100"
      headline="404"
      title="Page not found"
      image="/img/logo_abet.svg"
      max-width="500px"
    ></v-empty-state>
  </div>
</template>

<style scoped></style>
